import { useGoodsReviewsSummary } from '../queries/useGoodsReadReviewsSummary';
import { useMemo } from 'react';

export const useGoodsReviewSummaryItem = () => {
  const { data: reviewsSummary } = useGoodsReviewsSummary();

  const summaryItem = useMemo(() => {
    if (reviewsSummary.summary.length === 0) return null;

    return reviewsSummary.summary[0];
  }, [reviewsSummary.summary]);

  return summaryItem;
};
